import React, { useLayoutEffect, useState } from 'react';
import { signOut } from 'next-auth/react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { Icon } from '../../icons';
import { LinkButton, ButtonLink } from '../../atoms';
import { AddPupButton } from '../AddPupButton';
import {
  SlidingContainer,
  CtaButton,
  SlideoutMenuLink,
} from '../../components';
import tagIcon from '../../images/tag.svg';
import { useSessionCustomer } from '../../customer';
import { HeaderLink } from './HeaderLink';
import {
  DesktopNavigationMenu,
  MobileNavigationMenu,
  BurgerMenu,
  SlideOutMenu,
  GetStartedButton,
  MobileCtaButtonContainer,
  MobileButtonWrapper,
} from './NavigationBar/styles.js';
import { SmallNavLink } from './styles';

export const LoginMenuLinks = () => (
  <>
    <GetStartedButton>
      <LinkButton variant="egg" verticalPadding={3} href="/onboarding/">
        Get started
      </LinkButton>
    </GetStartedButton>
    <Link href="/auth/login/" passHref>
      <SmallNavLink>Login</SmallNavLink>
    </Link>
  </>
);

export const LoggedInMenuLink = () => {
  const { customer } = useSessionCustomer();

  return (
    <>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={tagIcon.src} alt="dog tag" />
      <Link href="/account/" passHref>
        <SmallNavLink>Hi, {customer?.first_name ?? 'friend'}</SmallNavLink>
      </Link>
    </>
  );
};

export const UserMenuLinks = () => {
  const { isActive } = useSessionCustomer();
  return isActive ? <LoggedInMenuLink /> : <LoginMenuLinks />;
};

export const LeftMenuLinks = ({ links }) => {
  const [showSideMenu, setShowSideMenu] = useState(false);
  const [slidingContainerOffset, setSlidngContainerOffset] = useState(0);
  const { isActive } = useSessionCustomer();

  const toggleSideMenu = () => {
    setShowSideMenu(!showSideMenu);
  };

  useLayoutEffect(() => {
    const nav = document.querySelectorAll('[role="navigation"]')[0];
    const { top, height } = nav.getBoundingClientRect();
    setSlidngContainerOffset(top + height);
  }, []);

  return (
    <>
      <DesktopNavigationMenu>
        {links.map((link, index) => {
          const { component } = link;
          if (component === 'slideout_menu_link')
            return <SlideoutMenuLink key={index} {...link} />;
          return (
            <HeaderLink
              target={link.target}
              position={index}
              text={link.text}
              type="desktop"
              key={index}
            />
          );
        })}
      </DesktopNavigationMenu>
      <MobileNavigationMenu>
        <BurgerMenu onClick={toggleSideMenu}>
          {showSideMenu ? (
            <Icon iconName="close" alt="burger menu" size={1} />
          ) : (
            <Icon iconName="menu" alt="burger menu" size={1} />
          )}
        </BurgerMenu>
        <SlidingContainer
          active={showSideMenu}
          onExit={toggleSideMenu}
          bgColor="background.base"
          alignment="left"
          offsetTop={slidingContainerOffset}
        >
          <>
            <SlideOutMenu>
              {links.map((link, index) => {
                const { component } = link;
                if (component === 'slideout_menu_link')
                  return (
                    <SlideoutMenuLink
                      {...link}
                      key={index}
                      onCloseMenu={toggleSideMenu}
                    />
                  );
                return (
                  <HeaderLink
                    target={link.target}
                    position={index}
                    text={link.text}
                    type="desktop"
                    key={index}
                    onClick={toggleSideMenu}
                  />
                );
              })}
              {isActive && (
                <>
                  <MobileButtonWrapper verticalMargin={7}>
                    <AddPupButton
                      href="/account/add-pup/"
                      fullWidth={true}
                      variant="blueberry"
                      verticalPadding={3}
                      horizontalPadding={3}
                      text="Add Pup"
                    />
                  </MobileButtonWrapper>
                  <MobileButtonWrapper verticalMargin={2}>
                    <ButtonLink onClick={signOut} variant="hero.cranberry">
                      Logout
                    </ButtonLink>
                  </MobileButtonWrapper>
                </>
              )}
            </SlideOutMenu>
            {!isActive && (
              <MobileCtaButtonContainer>
                <CtaButton href="/onboarding/" variant="egg" fullWidth={true}>
                  Get started
                </CtaButton>
              </MobileCtaButtonContainer>
            )}
          </>
        </SlidingContainer>
      </MobileNavigationMenu>
    </>
  );
};

LeftMenuLinks.displayName = 'MarketingMenuLinks';

LeftMenuLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      target: PropTypes.string,
      text: PropTypes.string,
      component: PropTypes.string,
    }),
  ),
};
